// ======================================================================
// File Name       : FormControlPassword
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form, FormControl } from 'react-bootstrap';
import DialogConfirm from '../components/DialogConfirm';
import MessageValidate from '../components/MessageValidate';
import {
  ERROR_TYPE,
  MODAL_SIZE,
  PASS_STRENGTH_TYPE,
  VALIDATE_TYPE
} from '../constants/index';
import * as MessageTemplate from '../constants/MessageTemplate';
/**
 * FormControlPassword
 * props: recordNum (total record)
 * props: handlePageSelect (return start,end position by page selected)
 */
class FormControlPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      errorType: ERROR_TYPE.SUCCESS,
      errorVisible: false,
      errorMessage: '',
      showAboutDialog: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.checkConsecutiveCharacterStrings = this.checkConsecutiveCharacterStrings.bind(this);
    this.validation = this.validation.bind(this);
    this.validateRequiredField = this.validateRequiredField.bind(this);
    this.validateWeakPass = this.validateWeakPass.bind(this);
    this.validateMediumPass = this.validateMediumPass.bind(this);
    this.validateStrongPass = this.validateStrongPass.bind(this);
    this.validatePassConfirm = this.validatePassConfirm.bind(this);
    this.openPasswordAboutDialog = this.openPasswordAboutDialog.bind(this);
    this.onPasswordAboutOk = this.onPasswordAboutOk.bind(this);
    this.message = '';
  }

  /**
     * Show more information when click
     */
  openPasswordAboutDialog() {
    this.setState({ showAboutDialog: true });
  }

  onPasswordAboutOk() {
    this.setState({ showAboutDialog: false });
  }

  /**
     * Check password following to consecutive character strings
     * @param {string} pass
     * @return {boolean} true if password is following to consecutive character strings
     */
  checkConsecutiveCharacterStrings(pass) {
    let rule = /(\w)(\w)\1\2/;
    // not characters like abab
    if (rule.test(pass)) {
      return false;
    }
    // no more than 3 of the same character in sequence
    rule = /(\w)\1{2,}/;
    if (rule.test(pass)) {
      return false;
    }

    rule = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[#-/:-@^-`{-~!\[\]])(?=(?:(?=[^\\\"])[!-~])+$).{10,}/;
    if (!rule.test(pass)) {
      return false;
    }
    // Check character like 123, abc
    let matchfound = false;
    const inRange = (code) => {
      const check = (code >= 49 && code <= 57)
      || (code >= 65 && code <= 90)
      || (code >= 97 && code <= 122);
      return check;
    };
    for (let i = 0; i <= pass.length - 3; i++) {
      const s1 = pass.charCodeAt(i);
      const s2 = pass.charCodeAt(i + 1);
      const s3 = pass.charCodeAt(i + 2);
      if (inRange(s1) && inRange(s2) && inRange(s3)) {
        if (Math.abs(s1 - s2) === 1 && s1 - s2 === s2 - s3) {
          matchfound = true;
          break;
        }
      }
    }
    if (matchfound) {
      return false;
    }
    const loginID = this.props.loginID;
    return pass.indexOf(loginID) === -1;
  }

  /**
     * Event change value of password input
     * @param {*} event
     */
  handleChange(event) {
    this.value = event.target.value;
    this.validation();
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  handleBlur(event) {
    this.value = event.target.value;
    this.validation();
  }

  /**
   * Message validate
   * @param {*} label
   * @param {*} msg
   */
  messageTemplate(label, msg) {
    return msg.replace('{0}', label);
  }

  validateRequiredField(value) {
    let isValid = true;
    if (this.props.required) {
      if (!value) {
        isValid = false;
        let label = this.props.label;
        if (!label) {
          label = (this.props.type === VALIDATE_TYPE.PASSWORD) ? 'パスワード' : 'パスワード（確認）';
        }
        this.message = this.messageTemplate(label, MessageTemplate.W_REQUIRED);
      }
    }
    return isValid;
  }

  validateWeakPass(pass) {
    let isValid = true;
    if (!pass) {
      return this.validateRequiredField(pass);
    }
    this.message = MessageTemplate.MSG_PASSWORD_VALID;
    const rule = /^(?:(?=[^\\\"])[!-~]){4,}$/;
    if (!rule.test(pass)) {
      isValid = false;
      const label = '標準';
      this.message = this.messageTemplate(label, MessageTemplate.MSG_PASSWORD_INVALID);
    }
    return isValid;
  }

  validateMediumPass(pass) {
    let isValid = true;
    if (!pass) {
      return this.validateRequiredField(pass);
    }
    this.message = MessageTemplate.MSG_PASSWORD_VALID;
    const rule = /^(?:(?=[^\\\"])[!-~]){8,}$/;
    if (!rule.test(pass)) {
      isValid = false;
      const label = '中';
      this.message = this.messageTemplate(label, MessageTemplate.MSG_PASSWORD_INVALID);
    }
    return isValid;
  }

  validateStrongPass(pass) {
    let isValid = true;
    if (!pass) {
      return this.validateRequiredField(pass);
    }
    isValid = this.checkConsecutiveCharacterStrings(pass);
    this.message = MessageTemplate.MSG_PASSWORD_VALID;
    if (!isValid) {
      const label = '強';
      this.message = this.messageTemplate(label, MessageTemplate.MSG_PASSWORD_INVALID);
    }
    return isValid;
  }

  validatePassConfirm(pass) {
    let isValid = true;
    if (!pass) {
      return this.validateRequiredField(pass);
    }
    this.message = MessageTemplate.MSG_PASSWORD_CONFIRM_MATCH;
    if (pass !== this.props.passwordConfirm) {
      isValid = false;
      this.message = MessageTemplate.MSG_PASSWORD_CONFIRM_NOT_MATCH;
    }
    return isValid;
  }

  // Step 11.0.0 START
  validateMinLength(pass) {
    let isValid = true;
    isValid = pass.length >= parseInt(this.props.minLength, 10);
    if (!isValid) {
      this.message = this.messageTemplate(this.props.minLength, MessageTemplate.W_MIN_NUMBER);
    }
    return isValid;
  }
  // Step 11.0.0 END

  validation() {
    let isValid = true;
    let errorType = ERROR_TYPE.SUCCESS;
    let errorVisible = false;
    const pass = this.value;
    const passStrType = parseInt(this.props.passStrType, 10);
    if (this.props.type === VALIDATE_TYPE.PASSWORD_CONFIRM) {
      isValid = this.validatePassConfirm(pass);
      if (this.props.confirmPassword && isValid) {
        return isValid;
      }
    } else if (this.props.type === VALIDATE_TYPE.PASSWORD) {
      switch (passStrType) {
        case PASS_STRENGTH_TYPE.WEAK: {
          isValid = this.validateWeakPass(pass);
          break;
        }
        case PASS_STRENGTH_TYPE.MEDIUM: {
          isValid = this.validateMediumPass(pass);
          break;
        }
        default: {
          isValid = this.validateStrongPass(pass);
          break;
        }
      }
    }
    // Step 11.0.0 START
    if (pass && this.props.minLength) {
      isValid = this.validateMinLength(pass);
    }
    // Step 11.0.0 END
    if (!isValid) {
      errorType = ERROR_TYPE.ERROR;
    }
    errorVisible = true;
    if (!pass && isValid === true) {
      errorVisible = false;
    }
    
    this.setState({ errorVisible, errorType, errorMessage: this.message });
    return isValid;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.type === VALIDATE_TYPE.PASSWORD_CONFIRM) {
      if (this.value) {
        if (this.value !== newProps.passwordConfirm){
          this.setState({
            errorVisible: true,
            errorType: ERROR_TYPE.ERROR,
            errorMessage: MessageTemplate.MSG_PASSWORD_CONFIRM_NOT_MATCH,
          });
        } else {
          this.setState({
            errorVisible: true,
            errorType: ERROR_TYPE.SUCCESS,
            errorMessage: MessageTemplate.MSG_PASSWORD_CONFIRM_MATCH,
          });
        }
      } else if (!newProps.required) {
        this.setState({ errorVisible: false });
      }
    }
    if (typeof newProps.value !== 'undefined') this.value = newProps.value;
  }

  render() {
    const { isChangePassword } = this.props;
    return (
      <Form.Group className="form-info">
        <Col
          as={Form.Label}
          sm={{
            span: this.props.labelSize ? this.props.labelSize : 3,
            offset: 0
          }}>
          {this.props.label
            ? this.props.label
            : this.props.type === VALIDATE_TYPE.PASSWORD ? 'パスワード' : 'パスワード（確認）'}
          {this.props.required && <span className="required">&nbsp;(※)</span>}
        </Col>
        <Col sm={this.props.inputSize ? this.props.inputSize : 5}>
          <FormControl
            type="password"
            maxLength="256"
            minLength={this.props.minLength} // Step 11.0.0
            name={this.props.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={this.props.value}
          />
          {
            this.props.showAbout &&
            <Col>
              <Button variant="link" className="padding-left-clear" onClick={this.openPasswordAboutDialog}>
                パスワードルール
            </Button>
            </Col>
          }
          {
            this.state.errorVisible && this.state.errorMessage !== '' &&
            <Col>
              <MessageValidate
                errorType={this.state.errorType}
                visible={this.state.errorVisible}
                errorMessage={this.state.errorMessage}
              />
            </Col>
          }
        </Col>
        <DialogConfirm
          showModal={this.state.showAboutDialog}
          leftContent
          mdSize={MODAL_SIZE.lg}
          label={MessageTemplate.ABOUT_PASSWORD_STRENGTH_TITLE}
          content={this.props.isStrongPasswordOnly ?
          MessageTemplate.ABOUT_PASSWORD_BODY_FOR_STRONG_ONLY :
          MessageTemplate.ABOUT_PASSWORD_STRENGTH_BODY}
          onOK={this.onPasswordAboutOk}
          className="modal-width-660"
        />
      </Form.Group>
    );
  }
}

export default FormControlPassword;
